/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {Route, Switch} from 'react-router-dom'

import PrivateRoute from '../security/PrivateRoute'
import {injectIntl} from 'react-intl';
import Troubleshooting from '../faults/troubleshooting/Troubleshooting'
import FaultDetail from '../faults/FaultDetail'
import Asset from '../assets/Asset'
import Fleet from '../fleets/Fleet'
import Administration from '../admin/Administration'
import UserDetail from '../admin/users/UserDetail'
import Notifications from '../notifications/Notifications'
import EngineHistory from '../assets/EngineHistory'
import AirtimeAsset from '../airtime/AirtimeDataLoader'
import Airtime from '../airtime/AirtimeMainPage'
import {ACTIVITY_TYPES} from '../security/SecurityConst'

import { ToastContainer}  from 'react-toastify'
import FleetDetail from "../admin/fleets/FleetDetail";
import AssetDetail from "../admin/assets/AssetDetail";
import Dwp from "../faults/dwp/Dwp";
import { SidebarLayout } from '@scuf/common';

class Content extends React.Component {

    generateRoute(navigationItem, key) {
        if (!navigationItem.public) {
            return <PrivateRoute key={key} exact path={navigationItem.path} component={navigationItem.component} access={navigationItem.access}/>
        } else {
            return <Route key={key} exact path={navigationItem.path} component={navigationItem.component}/>
        }
    }


    generateSidebarItem(navigationItem) {
        return <SidebarLayout.Sidebar.Item key={navigationItem.getName()} content={navigationItem.getName()} onClick={navigationItem.onClick} active={navigationItem.isActive()}/>
    }

    getPageContent() {
        return (
            <div id="page-content" style={{maxWidth: this.props.location.pathname.includes("troubleshooting") ? '100%' : ''}}>
                <Switch>
                    {this.props.navItems.map(this.generateRoute)}
                    <PrivateRoute exact path={"/assets/:assetId/faults/:faultId"} component={FaultDetail} access={[ACTIVITY_TYPES.ALL_ISSUES_READ]}/>
                    <PrivateRoute exact path={"/assets/:assetId/faults/:faultId/troubleshooting"} component={Troubleshooting} access={[ACTIVITY_TYPES.ALL_ISSUES_READ]}/>
                    <PrivateRoute exact path={"/assets/:assetId/faults/:faultId/dwp"} component={Dwp} access={[ACTIVITY_TYPES.ALL_ISSUES_READ]}/>
                    <PrivateRoute exact path={"/assets/:assetId"} component={Asset} access={[ACTIVITY_TYPES.ASSETS_READ]}/>
                    <PrivateRoute exact path={"/fleets/:fleetId"} component={Fleet} access={[ACTIVITY_TYPES.FLEETS_READ]}/>
                    <PrivateRoute exact path={"/administration/users"} component={Administration} access={[ACTIVITY_TYPES.USERS_READ]}/>
                    <PrivateRoute exact path={"/administration/users/:userId"} component={UserDetail} access={[ACTIVITY_TYPES.USERS_READ]}/>
                    <PrivateRoute exact path={"/administration/fleets"} component={Administration} access={[ACTIVITY_TYPES.FLEETS_READ]}/>
                    <PrivateRoute exact path={"/administration/fleets/:fleetId"} component={FleetDetail} access={[ACTIVITY_TYPES.FLEETS_READ]}/>
                    <PrivateRoute exact path={"/administration/assets"} component={Administration} access={[ACTIVITY_TYPES.ASSETS_READ]}/>
                    <PrivateRoute exact path={"/administration/assets/:assetId"} component={AssetDetail} access={[ACTIVITY_TYPES.ASSETS_READ]}/>
                    <PrivateRoute exact path={"/administration/learningLoop"} component={Administration} access={[ACTIVITY_TYPES.CONFIG_READ]}/>
                    <PrivateRoute exact path={"/administration/appConfig"} component={Administration} access={[ACTIVITY_TYPES.CONFIG_READ]}/>
                    <PrivateRoute exact path={"/notifications"} component={Notifications} access={[ACTIVITY_TYPES.ALL_ISSUES_READ]}/>
                    <PrivateRoute exact path={"/engineHistory"} component={EngineHistory} access={[ACTIVITY_TYPES.HDA_FUNCTIONALITIES, ACTIVITY_TYPES.ASSETS_READ]}/>
                    <Route exact path={"/airtime/session"} component={Airtime}/>
                    <PrivateRoute exact path={"/airtime/process"} component={AirtimeAsset} access={[ACTIVITY_TYPES.EXTERNAL_ACTIVITY]}/>
                    <PrivateRoute exact path={"/airtime/asset/:assetId/faults/:faultId"} component={FaultDetail} access={[ACTIVITY_TYPES.EXTERNAL_ACTIVITY]}/>
                    <PrivateRoute exact path={"/airtime/asset/:assetId/faults/:faultId/troubleshooting"} component={Troubleshooting} access={[ACTIVITY_TYPES.EXTERNAL_ACTIVITY]}/>
                    <PrivateRoute exact path={"/airtime/asset/:assetId/faults/:faultId/dwp"} component={Dwp} access={[ACTIVITY_TYPES.EXTERNAL_ACTIVITY]}/>
                    <PrivateRoute exact path={"/airtime/asset/:assetId"} component={Asset} access={[ACTIVITY_TYPES.EXTERNAL_ACTIVITY]}/>
                    <PrivateRoute exact path={"/airtime/engineHistory"} component={EngineHistory} access={[ACTIVITY_TYPES.EXTERNAL_ACTIVITY]}/>
                </Switch>
            </div>
        )
    }

    render() {
        return (
            <React.Fragment>
                <ToastContainer
                    hideProgressBar={true}
                    closeOnClick={false}
                    closeButton={false}
                    newestOnTop={true}
                    position="top-center"
                    toastClassName="toast-notification-wrap"
                />

                <SidebarLayout collapsed={this.props.collapsedLeftMenu} noIcons={true}>
                    <SidebarLayout.Sidebar>
                        {this.props.navItems.map(this.generateSidebarItem)}
                    </SidebarLayout.Sidebar>
                    <SidebarLayout.Content>
                        {this.getPageContent()}
                    </SidebarLayout.Content>
                </SidebarLayout>
            </React.Fragment>
        )
    }
}

export default injectIntl(withRouter(Content))